module.exports = __webpack_public_path__ + "static/img/23883ecb0eb029377b574434d18e3f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/图片3.png
// module id = umcQ
// module chunks = 1